export function isFormLoading(state) {
	return state.profile.loading;
}

export function getUserId(state) {
	return state.profile.id;
}
